import { Text } from '@consta/uikit/Text'
import { Timer } from '@consta/uikit/Timer'
import cn from 'classnames'
import type { FC } from 'react'

import css from './CommonStyles.css'

type LabeledTimerProps = { progress: number; text: string }

export const LabeledTimer: FC<LabeledTimerProps> = ({ progress, text }) => {
  return (
    <div data-testid="loading-progress" className={css.loadingFrame}>
      <Timer size="2xl" seconds={progress} progress={progress} className={css.loadingTimer} />
      <Text size="s" className={cn(css.loadingTimer, css.timerPosition)} view="primary">
        {text}
      </Text>
    </div>
  )
}
